<div *ngIf="!isLoading" class="section"
  style="flex: 1; display: flex; flex-direction: column; height: 100%; max-height: 100%; overflow: hidden;" data-cy="ar-insurance-payment">

  <div class="section-header" data-cy="ar-insurance-payment-header">
    <div class="section-header-title" data-cy="ar-insurance-payment-title">Insurance Payment</div>
  </div>

  <div class="section-content" style="display: flex; flex-direction: column; flex: 1; overflow: hidden;" data-cy="ar-insurance-payment-content">
    <div class="flexbox-container-row" data-cy="ar-insurance-payment-top-row">
      <div style="display: flex; width: 100%;flex-direction: column;flex: 5;" data-cy="ar-insurance-payment-left-column">
        <div *ngIf="!this.isClaimRefusal" style="padding-right:10px; padding-bottom:4px" data-cy="ar-insurance-payment-filters">
          <mat-checkbox class="example-margin" [(ngModel)]="showOnlyCurrentPatient" [color]="'primary'"
            (change)="showOnlyCurrentPatientChanged($event);" data-cy="ar-insurance-payment-current-patient-cb">
            For Current Patient: {{ this.currentPatientName }}
          </mat-checkbox>
          <mat-checkbox [(ngModel)]="this.includeClosed" (change)="includeClosedClaimsChanged($event)"
            style="margin-left: 20px;" data-cy="ar-insurance-payment-include-closed-cb">
            Include Closed
          </mat-checkbox>
        </div>
        <div *ngIf="!this.isClaimRefusal" class="flexbox-container" style="width:100% !important; flex-wrap: nowrap" data-cy="ar-insurance-payment-info-row">
          <div class="flexbox-item input-container-height" style="font-weight: bold;" *ngIf="this.pageModeType" data-cy="ar-insurance-payment-insurance-name">
            {{ this.insuranceName }}
          </div>
          <div class="flexbox-container-row" style="width:330px; flex-grow: 0" *ngIf="!this.pageModeType" data-cy="ar-insurance-payment-details">
            <div class="flexbox-item input-container-height" style="width: 250px;" data-cy="ar-insurance-payment-company-container">

              <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important; cursor: pointer;"
                (click)="selectInsurance($event)" data-cy="ar-insurance-payment-company-field">
                <mat-label data-cy="ar-insurance-payment-company-label">Insurance Company</mat-label>
                <input matInput style="cursor: pointer;" placeholder="Insurance Company"
                  [matTooltip]="this.selectedInsuranceCompany?.OrganizationName"
                  [value]="this.selectedInsuranceCompany?.OrganizationName" readonly data-cy="ar-insurance-payment-company-input" />
                <button mat-icon-button matSuffix data-cy="ar-insurance-payment-company-button">
                  <mat-icon>assured_workload</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="flexbox-item input-container-height" data-cy="ar-insurance-payment-method-container">
              <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;" data-cy="ar-insurance-payment-method-field">
                <mat-label data-cy="ar-insurance-payment-method-label">Payment Method</mat-label>
                <mat-select [(ngModel)]="selectedPaymentMethod" (selectionChange)="setPaymentMethod()" data-cy="ar-insurance-payment-method-select">
                  <mat-option *ngFor="let method of paymentMethods" [value]="method" data-cy="ar-insurance-payment-method-option">
                    {{ method.Name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="flexbox-item input-container-height" style="width: 150px;" data-cy="ar-insurance-payment-amount-container">
              <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;" data-cy="ar-insurance-payment-amount-field">
                <mat-label data-cy="ar-insurance-payment-amount-label">Total Amount</mat-label>
                <input matInput [value]="paymentAmount | currency:'USD':'symbol'"
                  (change)="saveTotalAmount($event);" data-cy="ar-insurance-payment-amount-input">
              </mat-form-field>
            </div>
            <div class="flexbox-item input-container-height" style="width: 175px;" data-cy="ar-insurance-payment-date-container">
              <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;" data-cy="ar-insurance-payment-date-field">
                <mat-label data-cy="ar-insurance-payment-date-label">Post Date</mat-label>
                <input matInput [matDatepicker]="dateReceivedPicker" [(ngModel)]="datePostPayment"
                  [min]="this.datePostPaymentMin" data-cy="ar-insurance-payment-date-input">
                <mat-datepicker-toggle matSuffix [for]="dateReceivedPicker" data-cy="ar-insurance-payment-date-toggle"></mat-datepicker-toggle>
                <mat-datepicker #dateReceivedPicker data-cy="ar-insurance-payment-date-picker"></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="flexbox-item" style="flex-grow: 1.5" data-cy="ar-insurance-payment-description-container">
              <mat-form-field class="flex-column-item mat-select-margin" style="width:100%" data-cy="ar-insurance-payment-description-field">
                <mat-label data-cy="ar-insurance-payment-description-label">Description</mat-label>
                <input matInput value="" [(ngModel)]="paymentDescription" data-cy="ar-insurance-payment-description-input">
              </mat-form-field>
            </div>
            <div class="flexbox-item input-container-heighta autowidth" *ngIf="!this.pageModeType" data-cy="ar-insurance-payment-account-container">
              <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;" data-cy="ar-insurance-payment-account-field">
                <mat-label data-cy="ar-insurance-payment-account-label">AR Account</mat-label>
                <mat-select [(ngModel)]="selectedARAccount" data-cy="ar-insurance-payment-account-select">
                  <mat-option *ngFor="let account of arAccounts" [value]="account" data-cy="ar-insurance-payment-account-option">
                    {{ account.AccountName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="flexbox-container document-section" data-cy="ar-insurance-payment-documents">
        <div class="flexbox-container" style="flex: 1;border-bottom: 1px solid #0063A7;" data-cy="ar-insurance-payment-doc-buttons">
          <div style="flex:1;text-align: center;" data-cy="ar-insurance-payment-scan-container">
            <button class="tdo-button tdo-save document-icon" [matMenuTriggerFor]="scanMenu" data-cy="ar-insurance-payment-scan-button">Scan
              <span class="material-icons-outlined" style="font-size: 13px;"
                [matTooltip]="'Scan Attachment'" data-cy="ar-insurance-payment-scan-icon">scanner</span>
            </button>
            <mat-menu #scanMenu="matMenu" data-cy="ar-insurance-payment-scan-menu">
              <button mat-menu-item *ngFor="let tag of this.insuranceDocumentTags" (click)="openDrawInNewWindow(tag.ValidValueItemId, tag.ItemDisplayValue)" data-cy="ar-insurance-payment-scan-menu-item">
                <mat-icon>description</mat-icon>
                <span> {{tag.ItemDisplayValue}}</span>
              </button>
            </mat-menu>
          </div>
          <div style="flex:1;text-align: center;" data-cy="ar-insurance-payment-upload-container">
            <input #fileInput id="fileInput" style="display:none;" type="file" accept="image/png, image/jpeg"
              (change)="fileSelected(fileInput.files)" (click)="$event.target.value=null" data-cy="ar-insurance-payment-file-input" />
            <button class="tdo-button tdo-save document-icon" [matMenuTriggerFor]="uploadMenu" data-cy="ar-insurance-payment-upload-button">Upload
              <span class="material-icons-outlined" style="font-size: 13px;"
                [matTooltip]="'Attach File'" data-cy="ar-insurance-payment-upload-icon">upload_file</span>
            </button>
            <mat-menu #uploadMenu="matMenu" data-cy="ar-insurance-payment-upload-menu">
              <button mat-menu-item *ngFor="let tag of this.insuranceDocumentTags" (click)="openUpload(tag.ValidValueItemId, tag.ItemDisplayValue)" data-cy="ar-insurance-payment-upload-menu-item">
                <mat-icon>description</mat-icon>
                <span> {{tag.ItemDisplayValue}}</span>
              </button>
            </mat-menu>
          </div>
        </div>
        <div class="flexbox-container document-list" style="flex: 2;text-align: center;" data-cy="ar-insurance-payment-doc-list">
          <div style="flex-direction: row; display: flex; cursor: pointer;width: 100%;" *ngFor="let file of this.insuranceDocuments"
            (click)="openInsuranceFile(file)" data-cy="ar-insurance-payment-doc-item">
            <div style="flex-direction: row; display: flex;" data-cy="ar-insurance-payment-doc-item-row">
              <div style="align-content: space-evenly;" data-cy="ar-insurance-payment-doc-icon-container">
                <i class="tiny-icon material-symbols-outlined insurance-document-icon" data-cy="ar-insurance-payment-doc-icon">file_open</i></div>
                <div class="insurance-document" data-cy="ar-insurance-payment-doc-info">
                  {{ file.Description }} ({{ file.DocumentCreateDate | date:'short' }})
                </div>
            </div>
          </div>
          <div *ngIf="!(this.insuranceDocuments?.length > 0)" style="width: 100%;text-align: center;" data-cy="ar-insurance-payment-no-docs">
            No documents attached
          </div>
        </div>
      </div>
    </div>
    <div data-cy="ar-insurance-payment-buttons-row">
      <div class="flexbox-container" style="width:1100px !important; flex-wrap: wrap" data-cy="ar-insurance-payment-buttons-container">
        <div class="flexbox-container-column" style="flex-direction: column-reverse;" data-cy="ar-insurance-payment-submit-container">
          <div style="width:430px" data-cy="ar-insurance-payment-submit-button-container">
            <button class="tdo-button tdo-save" *ngIf="this.isClaimRefusal" (click)="submitPayment()" data-cy="ar-insurance-payment-submit-button">
              Submit Claim Refusal
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- claims table -->

    <div style="width:100%; height: 100%" data-cy="ar-insurance-payment-claims">
      <div class="flexbox-container-row" style="flex-grow: 0" data-cy="ar-insurance-payment-detailsClaim">
      <div style="display: flex;flex-flow: row-reverse; width:590px" class="input-container-height"
        *ngIf="!isClaimRefusal" data-cy="ar-insurance-payment-search-bar">
        <mat-form-field class="flex-column-item mat-select-margin" style="width:400px !important;" data-cy="ar-insurance-payment-search-field">
          <mat-label data-cy="ar-insurance-payment-search-label">Search Claim # or Patient Name</mat-label>
          <input matInput id="'search-claim-input'" [(ngModel)]="searchInput" (keyup)="searchChanged($event)" data-cy="ar-insurance-payment-search-input">
        </mat-form-field>
        <button (click)="clearSearchBox()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="ar-insurance-payment-clear-search">Clear
          Search</button>
      </div>
      <div class="flexbox-item input-container-height" style="width: 205px; padding-left: 20px;" data-cy="ar-insurance-payment-date-received-container">
        <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;" data-cy="ar-insurance-payment-date-received-field">
          <mat-label data-cy="ar-insurance-payment-date-received-label">Date Received</mat-label>
          <input matInput [matDatepicker]="dateReceivedPaymentPicker" [(ngModel)]="dateReceivedPayment"
            [min]="this.dateReceivedMin" [disabled]="isDisabledReceivedDate" data-cy="ar-insurance-payment-date-input">
          <mat-datepicker-toggle matSuffix [for]="dateReceivedPaymentPicker" data-cy="ar-insurance-payment-date-received-toggle"></mat-datepicker-toggle>
          <mat-datepicker #dateReceivedPaymentPicker data-cy="ar-insurance-payment-date-received-picker"></mat-datepicker>
        </mat-form-field>
      </div>
      </div>

      <div *ngIf="!isClaimRefusal" style="flex-direction: row;display: flex;" data-cy="ar-insurance-payment-claim-info">
        <div style="padding-top:10px;flex: 2;" data-cy="ar-insurance-payment-claim-count">
          List of Claims ({{ claimsRows.length }} of {{ this.claimTotalNumber }})
        </div>
        <div style="flex: 2; text-align: right;" data-cy="ar-insurance-payment-remaining-amount">
          <span class="applyPayment-payment-distribution-amount" data-cy="ar-insurance-payment-remaining-value">{{ this.paymentAmountNotDistributed | currency
            }}</span>
          &nbsp;<span style="font-weight: bold" data-cy="ar-insurance-payment-remaining-label">Remaining For Distribution</span>
        </div>
        <div style="flex: 1; text-align: right" data-cy="ar-insurance-payment-clear-distributions-container">
          <button data-cy="pay-clear-distributions-btn" class="tdo-button tdo-save" (click)="clearDistributions()">
            Clear Distributions
          </button>
        </div>
      </div>

      <div style="width:100%;" data-cy="ar-insurance-payment-claims-header">
        <div class="trans_header_item_cell trans_item_cell_width_pct_10" data-cy="ar-insurance-payment-header-date">Date</div>
        <div class="trans_header_item_cell trans_item_cell_width_pct_10" data-cy="ar-insurance-payment-header-claim">Claim No</div>
        <div class="trans_header_item_cell"
          [ngClass]="!isClaimRefusal ? 'trans_item_cell_width_pct_20' : 'trans_item_cell_width_pct_30'" data-cy="ar-insurance-payment-header-patient">Patient</div>
        <div class="trans_header_item_cell trans_item_cell_width_pct_10" data-cy="ar-insurance-payment-header-total">Claim Total</div>
        <div class="trans_header_item_cell trans_item_cell_width_pct_10" data-cy="ar-insurance-payment-header-estimate">Ins Estimate</div>
        <div class="trans_header_item_cell trans_item_cell_width_pct_10" data-cy="ar-insurance-payment-header-due">Ins Due</div>
        <div class="trans_header_item_cell trans_item_cell_width_pct_10" data-cy="ar-insurance-payment-header-account">AR Account</div>
        <div class="trans_header_item_cell trans_item_cell_width_pct_10" *ngIf="!isClaimRefusal" data-cy="ar-insurance-payment-header-apply">Apply</div>
        <div class="trans_header_item_cell trans_item_cell_width_pct_5" data-cy="ar-insurance-payment-header-close">Close</div>
        <div class="trans_header_item_cell trans_item_cell_width_pct_5" data-cy="ar-insurance-payment-header-view">View</div>
      </div>
      <div *ngIf="isClaimsLoading" style="width:100%; height: 100%" data-cy="ar-insurance-payment-claims-loading">
        <mat-progress-bar mode="indeterminate" data-cy="ar-insurance-payment-claims-progress"></mat-progress-bar>
      </div>
      <div *ngIf="!isClaimsLoading" class="main-content-container"
        style="display: flex; flex-direction: column; overflow-y: auto" data-cy="ar-insurance-payment-claims-list">
        <div *ngFor="let claim of claimsRows; let i = index" style="width:100%" [class.offset-item]="i % 2"
          [ngClass]="claim.ClosedSearchResultSort == 0 ? 'closedSearchItem' : ''" data-cy="ar-insurance-payment-claim-row">

          <div [class.search-found]="claim.searchResult" data-cy="ar-insurance-payment-claim-item">
            <div class="trans_item trans_item_cell_width_pct_10" data-cy="ar-insurance-payment-claim-date">
              {{ claim.xauditCreatedOn | date }}
            </div>

            <div class="trans_item trans_item_cell_width_pct_10" id="{{ 'search-claim-row-' + claim.TDOClaimNumber }}" data-cy="ar-insurance-payment-claim-number">
              {{ claim.TDOClaimNumber }}
            </div>

            <div class="trans_item"
              [ngClass]="!isClaimRefusal ? 'trans_item_cell_width_pct_20' : 'trans_item_cell_width_pct_30'" data-cy="ar-insurance-payment-claim-patient">
              {{ claim.PatientFirstName + ' ' + claim.PatientLastName }}
            </div>

            <div class="trans_item trans_item_cell_width_pct_10" data-cy="ar-insurance-payment-claim-amount">
              {{ claim.ClaimAmount | currency }}
            </div>

            <div class="trans_item trans_item_cell_width_pct_10" data-cy="ar-insurance-payment-claim-estimate">
              {{ claim.InsEstimateAmountTotal | currency }}
            </div>

            <div class="trans_item trans_item_cell_width_pct_10" data-cy="ar-insurance-payment-claim-due">
              {{ claim.InsEstimateAmountDue | currency }}
            </div>

            <div class="trans_item trans_item_cell_width_pct_10 input-container-height" *ngIf="isClaimRefusal" data-cy="ar-insurance-payment-claim-account-name">
              {{ selectedARAccount?.AccountName }}
            </div>
            <div class="trans_item trans_item_cell_width_pct_10 input-container-height" *ngIf="!isClaimRefusal" data-cy="ar-insurance-payment-claim-account-select-container">
              <mat-form-field floatLabel='never' class="flex-column-item" style="width:100% !important;" data-cy="ar-insurance-payment-claim-account-field">
                <mat-label data-cy="ar-insurance-payment-claim-account-label">AR Account</mat-label>
                <mat-select [(value)]="claim.DoctorARLocId" data-cy="ar-insurance-payment-claim-account-select">
                  <mat-option *ngFor="let account of arAccounts" [value]="account.DoctorARLocId" data-cy="ar-insurance-payment-claim-account-option">
                    {{ account.AccountName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="trans_item trans_item_cell_width_pct_10 input-container-height" *ngIf="!isClaimRefusal" data-cy="ar-insurance-payment-claim-apply-container">
              <mat-form-field floatLabel='never' [style.width.px]=100 data-cy="ar-insurance-payment-claim-apply-field">
                <input matInput placeholder="" width="100px" style="font-weight: bold"
                  (change)="saveCurrencyField($event, 'ApplyPayment', claim.ARClaimID, '');"
                  [ngModel]="claim.ApplyPayment | currency" data-cy="ar-insurance-payment-claim-apply-input">
              </mat-form-field>
            </div>

            <div class="trans_item trans_item_cell_width_pct_5" style="text-align: center; padding-top: 20px" data-cy="ar-insurance-payment-claim-close-container">
              <mat-checkbox class="inline-checkbox" [(ngModel)]="claim.MarkedForClose" data-cy="ar-insurance-payment-claim-close-checkbox">
              </mat-checkbox>
            </div>

            <div class="trans_item trans_item_cell_width_pct_5" data-cy="ar-insurance-payment-claim-expand-container">
              <button mat-icon-button *ngIf="!claim.claimExpanded" (click)="claim.claimExpanded = true"
                [matTooltip]="'View Claim Items'" data-cy="ar-insurance-payment-claim-expand-button">
                <mat-icon>expand_more</mat-icon>
              </button>
              <button mat-icon-button *ngIf="claim.claimExpanded" (click)="claim.claimExpanded = false"
                [matTooltip]="'Hide Claim Items'" data-cy="ar-insurance-payment-claim-collapse-button">
                <mat-icon>expand_less</mat-icon>
              </button>
            </div>
          </div>

          <div class="claim_items_container" *ngIf="claim.claimExpanded" data-cy="ar-insurance-payment-claim-items-container">

            <div *ngIf="claim.claimExpanded" data-cy="ar-insurance-payment-claim-items">
              <div class="claim_items_container_inner" *ngIf="claim.dataARClaimListItems.length" data-cy="ar-insurance-payment-claim-items-inner">

                <!-- claims table -->
                <div style="width:100%;" data-cy="ar-insurance-payment-claim-items-header">
                  <div class="claim_item_header_item_cell trans_item_cell_width_pct_10" data-cy="ar-insurance-payment-claim-items-header-date">Date</div>
                  <div class="claim_item_header_item_cell trans_item_cell_width_pct_10" data-cy="ar-insurance-payment-claim-items-header-code">Code</div>
                  <div class="claim_item_header_item_cell"
                    [ngClass]="!isClaimRefusal ? 'trans_item_cell_width_pct_30' : 'trans_item_cell_width_pct_40'" data-cy="ar-insurance-payment-claim-items-header-proc">
                    Procedure</div>
                  <div class="claim_item_header_item_cell trans_item_cell_width_pct_10" data-cy="ar-insurance-payment-claim-items-header-est">Ins Estimate</div>
                  <div class="claim_item_header_item_cell trans_item_cell_width_pct_10" data-cy="ar-insurance-payment-claim-items-header-pay">Payments</div>
                  <div class="claim_item_header_item_cell trans_item_cell_width_pct_10" data-cy="ar-insurance-payment-claim-items-header-bal">Balance</div>
                  <div class="claim_item_header_item_cell trans_item_cell_width_pct_10" *ngIf="!isClaimRefusal" data-cy="ar-insurance-payment-claim-items-header-apply">Apply
                    ({{ returnApplyAmountReamining(claim) | currency }})</div>
                  <div class="claim_item_header_item_cell trans_item_cell_width_pct_10" data-cy="ar-insurance-payment-claim-items-header-action">&nbsp;</div>
                </div>

                <div *ngIf="!isClaimsLoading" style="flex: 1; display: flex; flex-direction: column;" data-cy="ar-insurance-payment-claim-items-list">
                  <div *ngFor="let claimitem of claim.dataARClaimListItems; let i = index" style="width:100%" data-cy="ar-insurance-payment-claim-item-row">
                    <div class="trans_item trans_item_cell_width_pct_10" data-cy="ar-insurance-payment-claim-item-date">
                      {{ claimitem.CreationDate | date }}
                    </div>

                    <div class="trans_item trans_item_cell_width_pct_10" data-cy="ar-insurance-payment-claim-item-code">
                      {{ claimitem.Code }}
                    </div>

                    <div class="trans_item"
                      [ngClass]="!isClaimRefusal ? 'trans_item_cell_width_pct_30' : 'trans_item_cell_width_pct_40'" data-cy="ar-insurance-payment-claim-item-proc">
                      {{ claimitem.ProcedureName }}
                    </div>
                    <div class="trans_item trans_item_cell_width_pct_10" data-cy="ar-insurance-payment-claim-item-est">
                      {{ claimitem.InsuranceAmount | currency }}
                    </div>

                    <div class="trans_item trans_item_cell_width_pct_10" data-cy="ar-insurance-payment-claim-item-pay">
                      {{ claimitem.PaymentsTotal | currency }}
                    </div>

                    <div class="trans_item trans_item_cell_width_pct_10" data-cy="ar-insurance-payment-claim-item-bal">
                      {{ claimitem.AmountOutstanding | currency }}
                    </div>

                    <div class="trans_item trans_item_cell_width_pct_10 input-container-height"
                      *ngIf="!isClaimRefusal" data-cy="ar-insurance-payment-claim-item-apply-container">
                      <mat-form-field floatLabel='never' [style.width.px]=100 data-cy="ar-insurance-payment-claim-item-apply-field">
                        <input matInput placeholder="" width="100px" style="font-weight: bold"
                          [disabled]="!claim.ApplyPayment"
                          (change)="saveCurrencyField($event, 'ApplyPaymentClaimItem', claim.ARClaimID, claimitem.ARClaimItemID); "
                          [ngModel]="claimitem.ApplyPayment | currency" data-cy="ar-insurance-payment-claim-item-apply-input">
                      </mat-form-field>
                    </div>

                    <div class="trans_item trans_item_cell_width_pct_10 input-container-height"
                      style="padding-right: 10px;" *ngIf="isClaimRefusal" data-cy="ar-insurance-payment-claim-item-patient-pay">
                      Patient Pay
                    </div>
                    <div class="trans_item trans_item_cell_width_pct_10 input-container-height"
                      style="padding-right: 10px;" *ngIf="!isClaimRefusal" data-cy="ar-insurance-payment-claim-item-action-container">
                      <mat-form-field class="flex-column-item" style="width:100% !important;" floatLabel="never" data-cy="ar-insurance-payment-claim-item-action-field">
                        <mat-label data-cy="ar-insurance-payment-claim-item-action-label">Action</mat-label>
                        <mat-select [(value)]="claimitem.enumARInsurancePaymentActionID"
                          (selectionChange)="claimItemActionSelected(claim, claimitem);" data-cy="ar-insurance-payment-claim-item-action-select">
                          <mat-option *ngFor="let action of paymentActions" [value]="action.ValidValueItemId" data-cy="ar-insurance-payment-claim-item-action-option">
                            {{ action.ItemDisplayValue }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="!claim.dataARClaimListItems.length" data-cy="ar-insurance-payment-claim-no-items">
                This claim has no claim items.
              </div>
            </div>

          </div>
        </div>

        <div *ngIf="searchWasEmpty" style="width:100%; height: 100%; padding-top: 30px" data-cy="ar-insurance-payment-no-claims">
          There are no claims for the selected insurance company.
        </div>
      </div>
      <div class="action-container" data-cy="ar-insurance-payment-actions">
        <button *ngIf="!this.isClaimsLoading && !this.isClaimRefusal" class="tdo-button tdo-close"
          [disabled]="!this.showSaveButton" (click)="processPayment()" style="margin-left: 10px" data-cy="ar-insurance-payment-process-button">Process</button>
        <!-- need status for when to light button up -->
        <button class="tdo-button tdo-close" (click)="cancelClicked()" style="margin-left: 10px" data-cy="ar-insurance-payment-cancel-button">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="spinner-container" [class.payment-processing]="isPaymentProcessing"
  *ngIf="isLoading || isPaymentProcessing" data-cy="ar-insurance-payment-spinner-container">
  <mat-spinner data-cy="ar-insurance-payment-spinner"></mat-spinner>
</div>